import BotService from '../../../../services/BotService/BotService';
import {queryParamGenerator} from "../../../../helpers/helper";

const getAllFilters = async (filter) => {
    let allFilter = [];
    let atfFilter = queryParamGenerator(filter.atf);
    await BotService.getAutomationTypesFilter(atfFilter).then((response) => {
        allFilter = [...allFilter, {name: 'Automation Type', filter: response?.data}];
    });
    await BotService.getBotBusinessProcess().then((response) => {
        allFilter = [...allFilter, {name: 'Business Process', filter: response?.data}];
    });
    await BotService.getCategoryFilter().then((response) => {
        allFilter = [...allFilter, {name: 'Category', filter: response?.data}];
    });
    await BotService.getBotSecurityFilter().then((response) => {
        allFilter = [...allFilter, {name: 'Security Stage', filter: response?.data}];
    });
    await BotService.getApplicationFilter().then((response) => {
        allFilter = [...allFilter, {name: 'Application', filter: response?.data}];
    });
    return allFilter;
}
export default getAllFilters;
